export default ({ className, ...htmlAttributes }: { className?: string }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		className={className}
		{...htmlAttributes}
	>
		<path
			d="M17 10.625C17 8.20312 15.6719 5.9375 13.5625 4.6875C11.4141 3.47656 8.79688 3.47656 6.6875 4.6875C4.53906 5.9375 3.25 8.20312 3.25 10.625C3.25 13.0859 4.53906 15.3516 6.6875 16.6016C8.79688 17.8125 11.4141 17.8125 13.5625 16.6016C15.6719 15.3516 17 13.0859 17 10.625ZM15.3984 16.7969C13.9922 18.0469 12.1172 18.75 10.125 18.75C5.63281 18.75 2 15.1172 2 10.625C2 6.17188 5.63281 2.5 10.125 2.5C14.5781 2.5 18.25 6.17188 18.25 10.625C18.25 12.6562 17.5078 14.4922 16.2969 15.9375L21.8047 21.4453C22.0391 21.6797 22.0391 22.1094 21.8047 22.3438C21.5703 22.5781 21.1406 22.5781 20.9062 22.3438L15.3984 16.7969Z"
			fill="currentColor"
		/>
	</svg>
);
